import { h, Component } from "preact";
import { DotScale } from "styled-loaders";

const translationLV = {
  BERTHED: "Ostā",
  EXPECTED: "Plānots",
  MOVING: "Kustībā",
  RAID: "Reidā",
  COMPLETED: "Pabeigta",
};

const translationRU = {
  BERTHED: "В ПОРТУ ",
  EXPECTED: "ОЖИДАЕТСЯ",
  MOVING: "В ДВИЖЕНИЕ",
  RAID: "В РЕЙД",
  COMPLETED: "ЗАКОНЧЕННЫЙ",
};

const mapLink = {
  lv: "/lv/karte",
  en: "/en/map",
  ru: "/ru/karta",
};

const passengerCountTranslations = {
  lv: "Pasažieru skaits: ",
  en: "Passenger capacity: ",
  ru: "Пассажировместимость: ",
};

const shipInformationTranslations = {
  lv: "Informācija par kuģi",
  en: "Ship details",
  ru: "Информация о судне",
}

const cruiseOperatortranslations = {
  lv: "Kuģa aģents: ",
  en: "Agent: ",
  ru: "Агент: ",
};

const showContactsTranslations = {
  lv: "Rādīt kontaktus",
  en: "Show contacts",
  ru: "Контакты",
};

const fromTranslations = {
  lv: "no",
  en: "from",
  ru: "с",
};

const tillTranslations = {
  lv: "līdz",
  en: "till",
  ru: "до",
};

const berthTranslations = {
  lv: "piestātne:",
  en: "berth:",
  ru: "причал:",
};

export default class ShipsInPort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ships: [],
      language: "",
      loaded: false,
      extraRowsLoaded: true,
      disableButton: false,
      activeItem: null,
      initialCount: 10, // number of ships to render initially
      loadCount: 10, // number of ships to load as the user scrolls down
      allowedLoadTimes: 0,
      timesLoaded: 0,
      datePickerYears: [],
      selectedYear: new Date().getFullYear(),
    };
  }

  loadMore = () => {
    if (this.state.timesLoaded < this.state.allowedLoadTimes) {
      const { initialCount, loadCount } = this.state;
      const newCount = initialCount + loadCount;
      this.setState({ extraRowsLoaded: false });
      setTimeout(() => {
        this.setState({ initialCount: newCount });
        this.setState({ timesLoaded: this.state.timesLoaded + 1 });
        this.setState({ extraRowsLoaded: true });
      }, 500);
    }
  };

  handleScroll = () => {
    if (this.state.disableButton && this.state.extraRowsLoaded) {
      const { innerHeight } = window;
      const { scrollHeight } = document.body;

      const scrollTop =
        (document.documentElement && document.documentElement.scrollTop) ||
        document.body.scrollTop;

      if (scrollHeight - innerHeight - scrollTop < 200) {
        this.loadMore();
      }
    }
  };

  handleYearChange = (event) => {
    this.setState(
      {
        selectedYear: event.target.value,
        disableButton: false,
        timesLoaded: 0,
        initialCount: 10,
      },
      () => {
        this.getCruiseData(5);
      }
    );
  };

  /**
   * Attach statuses from shipsForRop to the input ships
   *
   * @param {array} ships - array of ship objects
   */
  attachStatuses = (ships) => {
    return fetch("https://oks.rop.lv/api/v1/getShipsForRop")
      .then((res) => res.json())
      .then((result) => {
        const today = new Date(); // Pievienots šodienas datuma inicializēšana
        today.setHours(0, 0, 0, 0); // Pievienots, lai šodienas laiku iestatītu uz 00:00:00 precīzai salīdzināšanai
        ships.forEach((ship) => {
          const ropShip = result.find(
            (ropShip) => ropShip.Imo === ship.shipImo
          );
          if (ropShip) {
            const eta = ship.eta ? new Date(ship.eta.replace(/-/g, "/")) : null; // Pievienots ETA datuma inicializēšana
            eta.setHours(0, 0, 0, 0); // Pievienots, lai eta laiku iestatītu uz 00:00:00 precīzai salīdzināšanai
            if (eta && eta <= today) { // Pievienots nosacījums, lai pārbaudītu, vai ETA ir šodienas datums vai agrāks
              ship.status = ropShip.Statuss;
            } else {
              ship.status = "EXPECTED"; // Pievienots, lai kuģiem ar nākotnes datumiem statuss būtu "Plānots"
            }
          } else {
            ship.status = "EXPECTED"; // Pievienots, lai kuģiem, kas nav atrasti, statuss būtu "Plānots"
          }
        });
        return ships;
      });
  };

  /**
   * Fetches all data about cruises
   */
  getCruiseData = async (amount) => {
    try {
      const response = await fetch("https://oks.rop.lv/api/v1/getCruiseShips");
      const result = await response.json();

      let activeShips = result.filter((ship) => ship.status);
      let plannedShips = result.filter((ship) => !ship.status);

      plannedShips.sort((a, b) => {
        const etaA = a.eta ? new Date(a.eta.replace(/-/g, "/")) : null;
        const etaB = b.eta ? new Date(b.eta.replace(/-/g, "/")) : null;
        return etaA - etaB;
      });

      let potential = 0;
      let count = 0;
      let shipEtaYear = 0;
      const uniqueYears = new Set();
      plannedShips.map((ship) => {
        let currentTime = new Date();
        let shipEta = ship.eta ? new Date(ship.eta.replace(/-/g, "/")) : null;
        let shipEtd = ship.etd ? new Date(ship.etd.replace(/-/g, "/")) : null;

        if (shipEta) {
          if (
            shipEtaYear != shipEta.getFullYear() &&
            shipEta.getFullYear() >= currentTime.getFullYear()
          ) {
            uniqueYears.add(shipEta.getFullYear());
            shipEtaYear = shipEta.getFullYear();
          }

          {
            /* Only 5 of planned ships are shown */
          }
          if (
            (shipEta >= currentTime || shipEtd >= currentTime) &&
            shipEta.getFullYear() == this.state.selectedYear
          ) {
            if (count < amount || amount == 0) {
              activeShips.push(ship);
              count++;
            }
            potential++;
          }
        } else {
          if (shipEtd >= currentTime) {
            if (count < amount || amount == 0) {
              activeShips.push(ship);
              count++;
            }
            potential++;
          }
        }
      });
      if (potential < 6) {
        this.setState({ disableButton: true });
      }
      const setValues = Array.from(uniqueYears);
      this.setState({ datePickerYears: setValues });
      if (amount == 0) {
        count < 5
          ? this.setState({
              allowedLoadTimes: 0,
            })
          : this.setState({
              allowedLoadTimes: Math.round((count - 5) / this.state.loadCount),
            });
      }
      activeShips = await this.attachStatuses(activeShips); // Pievienots, lai izsauktu atjaunināto attachStatuses metodi
      this.setState({
        ships: activeShips,
        loaded: true,
      });
    } catch (error) {
      console.error("An error occurred while fetching cruise data:", error);
    }
  };

  /**
   * URL for all ship data API
   *
   * @returns {string} all ships in port API url
   */
  getShipLink = () => {
    return "https://oks.rop.lv/api/v1/getShipsForRop";
  };

  /**
   * Fetches data about all ships in port
   */
  getShipsInPort = () => [
    fetch(this.getShipLink())
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            shipsInPort: result,
          });
        },
        (error) => {
          console.log("kļūda");
        }
      ),
  ];

  /**
   * Sets language based on url
   */
  setLanguageState = () => {
    if (window.location.href.includes("/lv")) {
      this.setState({ language: "lv" });
    } else if (window.location.href.includes("/ru")) {
      this.setState({ language: "ru" });
    } else if (window.location.href.includes("/en")) {
      this.setState({ language: "en" });
    }
  };

  /**
   * Translates the ship status to required language
   *
   * @param {object} ship - instance of ship
   */
  renderStatus = (ship) => {
    if (ship.status) {
      let stateText;

      switch (this.state.language) {
        case "lv":
          stateText = translationLV[ship.status];
          break;

        case "ru":
          stateText = translationRU[ship.status];
          break;

        default:
          stateText = ship.status;
      }

      return (
        <div className="cruise-status">
          <div>{stateText}</div>
        </div>
      );
    } else {
      stateText='EXPECTED';

      switch (this.state.language) {
        case "lv":
          stateText = translationLV['EXPECTED'];
          break;

        case "ru":
          stateText = translationRU['EXPECTED'];
          break;

        default:
          stateText = 'EXPECTED';
      }

      return (
        <div className="cruise-status">
          <div>{stateText}</div>
        </div>
      );
    }
  };

  /**
   * Creates renderable list of cruise ships
   *
   * @returns {Array} list of renderable ship cards
   */
  renderShipList = () => {
    // let count = 0;
    return this.state.ships.map((ship, i) => {
      // let currentTime = new Date();
      // let shipEta = new Date(ship.eta.replace(/-/g, "/"));
      // let shipEtd = ship.etd ? new Date(ship.etd.replace(/-/g, "/")) : null;
      return (
        <div
          className={'cruise-ship-card'+(this.state.activeItem != i?'':' active-cruise')}
          key={i}
          onClick={() => {
            if (this.state.activeItem != i) {
              this.setState({ activeItem: i });
            } else {
              this.setState({ activeItem: null });
            }
          }}
        >
          <div className="cruise-top-part">
            <div className="cruise-card-left">
              <span>{ship._t_shipId}</span>
              <img className="cruise-yacht-image" src="/img/yacht-blue.svg" />
              {this.renderStatus(ship)}
            </div>
            <div className="cruise-card-right">
              {ship.eta ? (
                <span>
                  <span>{fromTranslations[this.state.language]}</span>
                  {new Date(ship.eta.replace(/-/g, "/")).toLocaleString(
                    "lv-LV",
                    {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </span>
              ) : null}
              {ship.etd ? (
                <span>
                  <span>{tillTranslations[this.state.language]}</span>
                  {new Date(ship.etd.replace(/-/g, "/")).toLocaleString(
                    "lv-LV",
                    {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </span>
              ) : null}
              <div class="cruise-berth">
                <div>{berthTranslations[this.state.language]}</div>
                <a href={mapLink[this.state.language]}>{ship._t_berthId}</a>
                <img src="/img/location3.svg" />
              </div>
            </div>
          </div>
          {this.renderShipInfo(ship, i)}
        </div>
      );
    });
  };

  /**
   * Creates an url that links to respective ship in "ships in port" page
   *
   * @param {number} imo - imo of ship that has a card in "ships in port" page
   * @returns {string} url to the card of the ship in "ships in port" page
   */
  linkToShip = (imo) => {
    if (!imo) {
      return false;
    }

    /* If ship is found within shipsInPort list, then a link is displayed */
    let foundShip = this.state.shipsInPort.find((ship) => ship.Imo == imo);

    if (foundShip) {
      var url = new URL(location.href);

      return url.origin + `/${this.state.language}/kugi-osta#${imo}`;
    } else {
      return false;
    }
  };

  /**
   * Renders ship info
   *
   * @param {ship} ship - instance of ship object
   * @param {number} i - index that is used to track which card is expanded
   */
  renderShipInfo = (ship, i) => {
    if (this.state.activeItem == i) {
      return (
        <div class="additional-cruise-ship-info">
          <div>
            {ship.sixtyPercentOfCapacity ? (
              <>
                <span>{passengerCountTranslations[this.state.language]}</span>
                <span class="additional-cruise-ship-info-value">
                  {ship.sixtyPercentOfCapacity}
                </span>
              </>
            ) : null}
            {this.linkToShip(ship.shipImo) ? (
              <>
                <a href={this.linkToShip(ship.shipImo)}>{shipInformationTranslations[this.state.language]}</a>
              </>
            ) : null}
          </div>
          {ship._t_companyId ? (
            <>
              <span>{cruiseOperatortranslations[this.state.language]}</span>
              <span class="additional-cruise-ship-info-value">
                {" "}
                {ship._t_companyId}
              </span>
              <a href={"/agent/" + ship.regNr}>
                {showContactsTranslations[this.state.language]}
              </a>
            </>
          ) : null}
        </div>
      );
    }
  };

  componentDidMount = () => {
    window.addEventListener("scroll", () => {
      this.handleScroll();
    });
    this.setLanguageState();
    this.getCruiseData(5);
    this.getShipsInPort();
  };

  render() {
    if (this.state.loaded) {
      return (
        <>
          <div class="select-wrapper">
            <select class="load-more-select" onChange={this.handleYearChange}>
              {this.state.datePickerYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div class="cruise-table-wrapper">
            {this.renderShipList()}
            {!this.state.extraRowsLoaded && <DotScale color="#063b59" />}
          </div>
          {!this.state.disableButton && (
            <button
              class="load-more"
              onClick={() => {
                this.getCruiseData(0);
                this.setState({ disableButton: true });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 298.68 298.68"
                fill="#fff"
                width="13px"
                height="13px"
                class="load-more-arrows"
              >
                <path d="M59.42.84H0l118.84 147.6L0 297.84h59.42l118.84-149.4z" />
                <path d="M179.84.84h-59.42l118.84 147.6-118.84 149.4h59.42l118.84-149.4z" />
              </svg>
              {this.state.language === "lv" ? "Ielādēt vairāk" : this.state.language === "en" ? "Load more" : this.state.language === "ru" ? "Загрузить больше" : "Ielādēt vairāk"}
            </button>
          )}
        </>
      );
    } else {
      // return <p>Loading</p>;
      return <DotScale color="#063b59" />;
    }
  }
}